import * as api from "../api";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import { DateFormatterDash } from "../../helpers/DateFormatter2";

export const GET_BATCH_BY_DATE_SUCCESS = "GET_BATCH_BY_DATE_SUCCESS";
export const CLEAR_BATCH_BY_DATE = "CLEAR_BATCH_BY_DATE";
export const GET_TRANSACTIONS_BY_BATCH = "GET_TRANACTIONS_BY_BATCH";
export const CLEAR_TRANSACTIONS_BY_BATCH = "CLEAR_TRANSACTIONS_BY_BATCH";

const convertToArrayBatch = (responseData) => {
  let dataArray = [];

  responseData.forEach((item) => {
    const formattedDate =
      item.date === null ? "-" : dayjs(item.date).format("DD MMMM, YYYY");
    const tempArray = [
      item.id,
      item.collector.name,
      item.collector.mobileNumber,
      formattedDate,
      item.status,
      item.totalTransaction,
    ];
    dataArray = [...dataArray, tempArray];
  });
  return dataArray;
};

export const getBatchByDate =
  (date, today = false) =>
  async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
      } = getState();
      let response;
      if (today) {
        response = await api.apiGetBatchToday(accessToken);
      } else {
        const formattedDate = DateFormatterDash(date);
        response = await api.apiGetBatchByDate(accessToken, formattedDate);
      }
      const finalCollectorArray = convertToArrayBatch(response.data);
      dispatch({
        type: GET_BATCH_BY_DATE_SUCCESS,
        payload: finalCollectorArray,
      });
    } catch (err) {
      toast.error(err.response ? err.response.data?.message : err.message);
    }
  };

export const clearBatchByDate = () => {
  return { type: CLEAR_BATCH_BY_DATE };
};
export const clearTransactionsByBatch = () => {
  return { type: CLEAR_TRANSACTIONS_BY_BATCH };
};

const AllTransactionsByIdArray = (responseData) => {
  let dataArray = [];
  responseData.forEach((item) => {
    const tempArray = [
      item.id,
      item.customerId,
      item.customerName,
      item.customerMobileNumber,
      item.amount,
      item.transactionType,
    ];
    dataArray = [...dataArray, tempArray];
  });
  return dataArray;
};

export const getTransactionsByBatchId = (id) => async (dispatch, getState) => {
  try {
    const {
      user: { accessToken },
    } = getState();
    const response = await api.apiGetTransactionsByBatch(accessToken, id);

    const transactionsList = AllTransactionsByIdArray(
      response.data.transactionList
    );
    const batchInfo = response.data;
    batchInfo.transactionList = undefined;

    dispatch({
      type: GET_TRANSACTIONS_BY_BATCH,
      individualBatchInfo: batchInfo,
      individualBatchTransactions: transactionsList,
    });
  } catch (err) {
    toast.error(err.response ? err.response.data?.message : err.message);
  }
};

export const verifyBatch =
  (batchId, handleSuccess, handleFailure) => async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
      } = getState();

      const response = await api.apiVerifyBatch(accessToken, batchId);
      toast.success("Batch has been verified successfully!");
      handleSuccess();
    } catch (err) {
      toast.error(err.response ? err.response.data?.message : err.message);
      handleFailure();
    }
  };
